<template>
  <header class="w-top">
    <div>
      <div class="w-title-line">
        <h1>Календарь приёма</h1>
      </div>
      <p class="w-context">{{ contextText }}</p>
    </div>
    <nav class="w-screen-nav" aria-label="Разделы расписания">
      <button
        type="button"
        :aria-pressed="String(store.screen === 'calendar')"
        @click="store.setScreen('calendar')"
      >
        <q-icon name="calendar_month" />
        Календарь по дням
      </button>
      <button
        v-if="store.canManage"
        type="button"
        :aria-pressed="String(store.screen === 'branch')"
        @click="store.setScreen('branch')"
      >
        <q-icon name="apartment" />
        Режим филиала
      </button>
    </nav>
    <div v-if="store.screen === 'calendar'" class="w-actions">
      <button
        class="w-button primary"
        type="button"
        :disabled="!store.canPlan"
        @click="store.toggleBuilder()"
      >
        <q-icon name="add" />
        Заполнить график
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';

const store = useScheduleStore();

const accessText = computed(() => {
  if (!store.canEdit) return 'просмотр';
  return store.mode === 'team' ? 'календарь сотрудника' : 'мой график';
});

const contextText = computed(() => (
  store.screen === 'branch'
    ? `${store.currentBranch?.name} · управление режимом работы`
    : `${store.staffDoctor?.name} · ${accessText.value}`
));
</script>
